module.exports = __webpack_public_path__ + "img/teff-grass.bd7ffb48.webp";